import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55db4654"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "event-table-container",
  ref: "eventTable"
}
const _hoisted_2 = { class: "event-table" }
const _hoisted_3 = {
  class: "event",
  width: "80"
}
const _hoisted_4 = ["data-id"]
const _hoisted_5 = {
  class: "eventValue",
  width: "48"
}
const _hoisted_6 = ["onUpdate:modelValue", "onChange"]
const _hoisted_7 = {
  class: "player",
  width: "130"
}
const _hoisted_8 = { class: "event-select" }
const _hoisted_9 = ["onUpdate:modelValue", "data-is-null", "onChange"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "選手を選ぶ", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  class: "time",
  width: "55"
}
const _hoisted_13 = ["onUpdate:modelValue", "onChange"]
const _hoisted_14 = {
  class: "delete",
  width: "40"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "score-footer" }
const _hoisted_19 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "event-table-row",
            key: event.id
          }, [
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("span", {
                class: "eventName",
                "data-id": event.event_id
              }, _toDisplayString(event.event_name), 9, _hoisted_4)
            ]),
            _createElementVNode("td", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                class: "event-input",
                "onUpdate:modelValue": ($event: any) => ((event.value) = $event),
                placeholder: "自由記入",
                onChange: ($event: any) => (_ctx.onChangeEvent(event))
              }, null, 40, _hoisted_6), [
                [_vModelText, event.value]
              ])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  class: "select",
                  "onUpdate:modelValue": ($event: any) => ((event.player_id) = $event),
                  "data-is-null": event.player_id === null,
                  onChange: ($event: any) => (_ctx.onChangeEvent(event))
                }, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rosters, (player) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: player.id,
                      value: player.id
                    }, _toDisplayString(player.number) + " " + _toDisplayString(player.player_name), 9, _hoisted_11))
                  }), 128))
                ], 40, _hoisted_9), [
                  [_vModelSelect, event.player_id]
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "event-input",
                "onUpdate:modelValue": ($event: any) => ((event.time) = $event),
                placeholder: "--:--",
                onChange: ($event: any) => (_ctx.onChangeEvent(event))
              }, null, 40, _hoisted_13), [
                [_vModelText, event.time]
              ])
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "global-delete-button",
                onClick: ($event: any) => (_ctx.onClickDeleteButton(event))
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          type: "button",
          class: "event-button -goal",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickEventButton(1, _ctx.teamType)))
        }, "ゴール"),
        _createElementVNode("button", {
          type: "button",
          class: "event-button -assist",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickEventButton(2, _ctx.teamType)))
        }, "アシスト"),
        _createElementVNode("button", {
          type: "button",
          class: "event-button -yellow",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickEventButton(3, _ctx.teamType)))
        }, "警告"),
        _createElementVNode("button", {
          type: "button",
          class: "event-button -red",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickEventButton(4, _ctx.teamType)))
        }, "退場")
      ])
    ])
  ], 64))
}